import React, { useState, useEffect } from 'react'
import Navber from '../Components/Navber.jsx'
import '../Styles/Group_tour.css'
import '../Styles/Package_tour.css'
import Common_tour_card from '../Components/Common_tour_card.jsx'
import Typemsg from '../Components/Typemsg.jsx'
import User_Destinations from '../Components/User_Destinations.jsx'
import api from '../Api.js'
import { Typography } from '@mui/material'
import CircularProgress from "@mui/material/CircularProgress"
import Box from "@mui/material/Box"
import Pagination from "@mui/material/Pagination"
import TourCardSkeleton  from "../Components/Helping Component/TourCardSkeleton.jsx"


function Group_tour() {
  const [sortOption, setSortOption] = useState("popularity")
   const [searchText, setSearchText] = useState("")
   const [tourData,setTourData] = useState([]);
   const [isLoading , setIsLoading] = useState(true)
    const [filteredItems, setFilteredItems] = useState([]);
   const [packageData,setPackageData] = useState([]);
  const [searchResult,setSearchResult] = useState("Search Results...")
 
const handleSortChange = (e) => {
  const selectedOption = e.target.value;
  setSortOption(selectedOption);
  console.log("Sort by:", selectedOption);

  let sortedData = [...filteredItems];

  switch (selectedOption) {
    case "price_low_high":
      sortedData.sort(
        (a, b) =>
          (a.tour?.pricing?.per_person?.adult || 0) -
          (b.tour?.pricing?.per_person?.adult || 0)
      );
      break;
    case "price_high_low":
      sortedData.sort(
        (a, b) =>
          (b.tour?.pricing?.per_person?.adult || 0) -
          (a.tour?.pricing?.per_person?.adult || 0)
      );
      break;
    case "duration":
      sortedData.sort(
        (a, b) => (a.tour?.no_of_days || 0) - (b.tour?.no_of_days || 0)
      );
      break;
    case "rating":
      sortedData.sort((a, b) => (b.rating || 0) - (a.rating || 0));
      break;
    case "popularity":
    default:
      // Optionally reset to original (unsorted)
      sortedData = [...packageData];
      break;
  }

  setFilteredItems(sortedData); // ✅ Update state so UI re-renders
};

 
   const handleSearch = () => {
     if(currentItems.length === 0){
       setSearchResult("...No Search Result...")
     }
     // here you can call API or filter your data
   }
   useEffect(()=>{
 
     const getPackages= async()=>{
         try{
           
           const res = await api.get("/tours/details?trip_type_id=5");
           console.log("Group Tour Cards: ",res?.data);
           if(res?.data?.success === true){
             setIsLoading(false)
             // setTourData(res?.data?.data);
             setPackageData(res?.data?.data);
             
           }
 
         }catch(error){
           console.log("package tour get karne main problem ho raha hai");
         }
     }
     getPackages();
   },[])
   // console.log("tour data in package tour page: ",packageData);
 const [page, setPage] = useState(1);
 
 const itemsPerPage = 6; // number of cards per page
 const totalPages = Math.ceil(filteredItems.length / itemsPerPage);
 
 const handleChange = (event, value) => {
   setPage(value);
 };
 
 // compute slice for current page:
 const startIndex = (page - 1) * itemsPerPage;
 const endIndex = startIndex + itemsPerPage;
 const currentItems = filteredItems.slice(startIndex, endIndex);
 
 
 
 useEffect(()=>{
       let data = [...packageData];
 
     if (searchText) {
       data = data.filter(
         (item) =>
           item.tour?.description?.toLowerCase().includes(searchText.toLowerCase()) ||
           item.tour?.title?.toLowerCase().includes(searchText.toLowerCase())||
           item.tour?.destination?.name.toLowerCase().includes(searchText.toLowerCase())||
           item.tour?.destination?.slug.toLowerCase().includes(searchText.toLowerCase())
       );
     }
     setFilteredItems(data);
       // update search result message
   if (searchText && data.length === 0) {
     setSearchResult("...No Search Result...");
   } else if (searchText) {
     setSearchResult(`Found ${data.length} result(s)`);
   } else {
     setSearchResult(""); // clear if no search
   }
 
   // reset to page 1 when search changes
   setPage(1);
 },[searchText,packageData])

 const sortOptions = [
  { key: "popularity", label: "Popularity" },
  { key: "price_low_high", label: "Price: Low → High" },
  { key: "price_high_low", label: "Price: High → Low" },
  { key: "duration", label: "Duration (Days)" },
  { key: "rating", label: "Rating" },
];


  return (
    <div style={{ minHeight: "100vh" }}>
      <div style={{ backgroundColor: "#f0f0f0" }}>
        <Navber />
      </div>
      <div className='group_container' style={{ background: `url(${require("../Images/grouptour1.jpg")}) center/cover no-repeat` }}>
        <h1
        style={{
  color: 'white',
  backgroundColor: 'rgba(0, 0, 0, 0.4)', // 40% black tint
  padding: '10px 20px',
  borderRadius: '8px',
  display: 'inline-block',
  backdropFilter: 'blur(4px)' // Adds a nice frosted glass effect
}}
        >Group Tour</h1>



      </div>
{/* <h3 style={{ padding: "0% 1%" }}>Top Picks</h3> */}

<div className="tourPageLayout">

  {/* LEFT STICKY FILTER PANEL */}
<div className="filterSidebar">

  {/* SEARCH ON TOP */}
  <div className="sidebarSearch">
    <h4>Search</h4>
    <input
      placeholder="Search tours..."
      value={searchText}
      onChange={(e) => setSearchText(e.target.value)}
    />
    <button onClick={handleSearch}>Search</button>
    {searchText && <p className="searchResult">{searchResult}</p>}
  </div>

  {/* SORTING SECTION */}
  <div className="sortSection">
    <h4>Sort By</h4>

    {sortOptions.map((option) => (
      <label key={option.key} className="sortOption">
        <input
          type="checkbox"
          checked={sortOption === option.key}
          onChange={() =>
            handleSortChange({ target: { value: option.key } })
          }
        />
        <span>{option.label}</span>
      </label>
    ))}
  </div>

</div>


  {/* RIGHT CARDS SECTION */}
  <div className="cardsSection">

    {isLoading ? (
  <div className="tourCardsGrid">
    {Array.from(new Array(6)).map((_, index) => (
      <TourCardSkeleton key={index} />
    ))}
  </div>
    ) : (
      <div className="tourCardsGrid">
        {currentItems.map((item) => (
          <Common_tour_card key={item.id} packagedata={item} />
        ))}
      </div>
    )}

    {!isLoading && (
      <div className="tourPaginationBar">
        <Pagination
          count={totalPages}
          page={page}
          onChange={handleChange}
          color="primary"
        />
      </div>
    )}

  </div>
</div>

     
      <User_Destinations />
       <Typemsg />



    </div>
  )
}

export default Group_tour
